// extracted by mini-css-extract-plugin
export default {"container":"style_container__HaaIq","wrapImage":"style_wrapImage__joKea","emptyIcon":"style_emptyIcon__Iuj0z","description":"style_description__vn1j+"};